const enTranslations = {
}

export default enTranslations;
